import React, { useEffect } from "react";
import Aos from "aos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "./award.scss";

export const Awards = ({ heading, awards }) => {
  return (
    <section id="award-section" className="w-full">
      {/* <h2
        data-aos="fade-up"
        className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px] text-left w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient mb-8"
      >
        {heading}
      </h2> */}

      <h2
        data-aos="fade-up"
        className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px] text-left w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient mb-8"
      >
        {heading}
      </h2>

      <div className="">
        <Swiper
          slidesPerView={2}
          freeMode={true}
          speed={2500}
          spaceBetween={7}
          centeredSlides={false}
          loop={true}
          grabCursor={false}
          modules={[FreeMode, Autoplay]}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 4,
              spaceBetween: 16,
            },
          }}
        >
          {awards?.map((award, i) => (
            <SwiperSlide>
              <div
                data-aos="fade-up"
                key={`award-${i}`}
                className="border border-white/30 flex justify-center items-center aspect-[16/8] w-full"
              >
                <img
                  src={award}
                  alt="Partners Logo"
                  className="!object-contain aspect-video max-w-[60%]"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Awards;
